import { render, staticRenderFns } from "./ReportSidebarAddNewCustomer.vue?vue&type=template&id=176486aa&"
import script from "./ReportSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./ReportSidebarAddNewCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports